// @ts-nocheck
import { aiMessageCaption } from './aiMessageMeta';

/** @param {{ source?: any }} props */
export default function AiCallLines({ source }) {
  const calls = Array.isArray(source?.ai_calls) ? source.ai_calls : [];
  const lines = (calls.length ? calls : [source]).map(aiMessageCaption).filter(Boolean);
  if (!lines.length) return null;
  return (
    <div className="mt-2 space-y-1">
      {lines.map((line, index) => (
        <p key={`${line}-${index}`} className="text-[13px] text-slate-600">{line}</p>
      ))}
    </div>
  );
}
